export enum EmergencialCoverageMode {
	untilNextCycleCoverage = 1,
	untilNextCycleDelivery = 2,
	emergencialCoverageModeNotDefined = 3,
}
